import { Link } from "react-router-dom";
import { Phone, MapPin, Mail } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#0F172A] text-white">
      <div className="section-container py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="w-9 h-9 rounded-lg overflow-hidden">
                <img src="https://customer-assets.emergentagent.com/job_bid-quality/artifacts/plxbtywa_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202026-03-12%20%D0%B2%2019.39.09.png" alt="AICallFront" className="w-full h-full object-cover" />
              </div>
              <span className="font-heading text-xl font-bold tracking-tight">
                AICallFront
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
              AI voice and chat receptionist for small businesses. Answer calls, capture leads,<br className="md:hidden" /> and book appointments automatically.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-slate-300 mb-5">
              Product
            </h4>
            <ul className="space-y-3">
              {[
                { label: "How It Works", id: "how-it-works" },
                { label: "Features", id: "features" },
                { label: "Who It's For", id: "use-cases" },
                { label: "Benefits", id: "benefits" },
              ].map((item) => (
                <li key={item.id}>
                  <a
                    href={`/#${item.id}`}
                    onClick={(e) => {
                      if (window.location.pathname === "/") {
                        e.preventDefault();
                        const el = document.getElementById(item.id);
                        if (el) el.scrollIntoView({ behavior: "smooth" });
                      }
                    }}
                    className="text-slate-400 hover:text-white text-sm transition-colors cursor-pointer"
                    data-testid={`footer-link-${item.id}`}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-slate-300 mb-5">
              Legal
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-privacy-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-terms-link">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-cookies-link">
                  Advertising & Cookies
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-slate-300 mb-5">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <MapPin className="w-4 h-4 text-[#3B82F6] mt-0.5 shrink-0" strokeWidth={1.5} />
                <span className="text-slate-400 text-sm leading-relaxed">
                  22 Tudor Street, City of London,<br className="md:hidden" /> London EC4Y 0AY, UK
                </span>
              </li>
              <li className="flex items-center gap-2.5">
                <Phone className="w-4 h-4 text-[#3B82F6] shrink-0" strokeWidth={1.5} />
                <a href="tel:+442039172500" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-phone">
                  +44 20 3917 2500
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <Mail className="w-4 h-4 text-[#3B82F6] shrink-0" strokeWidth={1.5} />
                <a href="mailto:info@aicallfront.com" className="text-slate-400 hover:text-white text-sm transition-colors" data-testid="footer-email">
                  info@aicallfront.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 text-center">
          <p className="text-slate-500 text-sm">
            &copy; {currentYear} AICallFront. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
